// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"847":"b1990a0a","879":"38a820e9"}[chunkId] + ".chunk.js";
};